(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 79007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgEmail; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgEmail(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}




/***/ }),

/***/ 5924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgMessage; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgMessage(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}




/***/ }),

/***/ 81114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgPerson; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgPerson(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}




/***/ }),

/***/ 4878:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(91580);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96324);
/* harmony import */ var _lendi_ui_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22294);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84209);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// @ts-ignore
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_lendi_ui_button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx).withConfig({
    componentId: "sc-869b14e0-0"
})(_templateObject(), _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__/* .margin */ .e);


/***/ }),

/***/ 91580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(89799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63518);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56158);
/* harmony import */ var _lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82419);
/* harmony import */ var _lendi_lala_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25980);
/* harmony import */ var _lendi_lendigroup_leads_library__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49481);
/* harmony import */ var launchdarkly_react_client_sdk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32735);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75514);
/* harmony import */ var _components_DisclaimerComponent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89915);
/* harmony import */ var _components_DividerComponent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24940);
/* harmony import */ var _components_EncryptionComponent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42496);
/* harmony import */ var _components_ErrorComponents__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51142);
/* harmony import */ var _components_FieldComponents__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8370);
/* harmony import */ var _components_GoogleSignInComponent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28270);
/* harmony import */ var _components_LaunchDarkly__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49932);
/* harmony import */ var _components_atoms_BoldHeading__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44556);
/* harmony import */ var _components_atoms_ButtonWithMargin__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67882);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(45343);
/* harmony import */ var _helpers_setPrlAndReferralParamsToStorage__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(18457);
/* harmony import */ var _helpers_router__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59060);
/* harmony import */ var _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(67458);
/* harmony import */ var _helpers_util__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(61414);
/* harmony import */ var _helpers_validation__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(89509);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(76417);
/* harmony import */ var _layout_AuthenticationFlowLayout__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(34526);
/* harmony import */ var _pages_styles_index_style__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(29580);
/* harmony import */ var _state_actionProvider__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(3842);
/* harmony import */ var _state_state__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(79826);
/* harmony import */ var _postcode__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(78842);































var Login = function() {
    var ref = (0,_state_state__WEBPACK_IMPORTED_MODULE_27__/* .useLALACustomerAppContext */ .g7)(), phoneNumber = ref.phoneNumber, error = ref.error, loading = ref.loading, codeSent = ref.codeSent;
    var ref1 = (0,_state_actionProvider__WEBPACK_IMPORTED_MODULE_26__/* .useActions */ .ol)(), sendCode = ref1.sendCode, resetError = ref1.resetError, resetSendCode = ref1.resetSendCode;
    var ref2 = (0,launchdarkly_react_client_sdk__WEBPACK_IMPORTED_MODULE_6__/* .useFlags */ .Vb)(), subbiesPostcodeBeforeAuth = ref2.subbiesPostcodeBeforeAuth, ssoSignIn = ref2.ssoSignIn;
    var brand = (0,_lendi_lala_react__WEBPACK_IMPORTED_MODULE_4__/* .useSession */ .kP)().brand;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_7__.useState(false), 2), postcodeHidden = ref3[0], hidePostcode = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_7__.useState(""), 2), referrer = ref4[0], setReferrer = ref4[1];
    var ref5 = react__WEBPACK_IMPORTED_MODULE_7__.useContext(_components_LaunchDarkly__WEBPACK_IMPORTED_MODULE_15__/* .LDContext */ .G), identifyCalled = ref5.identifyCalled, ldReady = ref5.ldReady;
    var params = new URLSearchParams(window.location.search);
    var textKey = params.get("textkey");
    var authFilter = params.get("auth");
    var hideOtp = authFilter === "sso";
    var hideSso = authFilter === "otp";
    var translationKeys = (0,_helpers__WEBPACK_IMPORTED_MODULE_18__/* .mapSignInTranslationKey */ .ZD)(referrer, textKey !== null && textKey !== void 0 ? textKey : undefined);
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_23__/* .useTranslate */ .qM)([
        translationKeys.title,
        translationKeys.subtitle
    ]), 2), title = ref6[0], subtitle = ref6[1];
    (0,_helpers_setPrlAndReferralParamsToStorage__WEBPACK_IMPORTED_MODULE_19__/* .setPrlAndReferralParamsToStorage */ .t)();
    var handleSubmit = function(values) {
        _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .eventTracking.trackAuthButtonClickEvent */ .fn.trackAuthButtonClickEvent("OTP", "Get one-time passcode");
        var phone = "+61".concat((0,_helpers_util__WEBPACK_IMPORTED_MODULE_30__/* .trimPhoneNumber */ .u3)(values.phoneNumber));
        sessionStorage.setItem("lala-phone", phone);
        sendCode(phone, undefined, function() {
            _helpers_router__WEBPACK_IMPORTED_MODULE_20__/* ["default"].push */ .Z.push({
                pathname: "/verify",
                query: _helpers_router__WEBPACK_IMPORTED_MODULE_20__/* ["default"].query */ .Z.query()
            });
        });
    };
    react__WEBPACK_IMPORTED_MODULE_7__.useEffect(function() {
        resetSendCode();
    }, []);
    react__WEBPACK_IMPORTED_MODULE_7__.useEffect(function() {
        var documentReferrer = (0,_helpers__WEBPACK_IMPORTED_MODULE_18__/* .getReferrer */ .an)() || "";
        setReferrer(documentReferrer);
        if (!identifyCalled) return;
        if (documentReferrer.includes(_lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.BOOKING_APPOINTMENT_BUYERS_AGENT_PATHNAME */ .C1.BOOKING_APPOINTMENT_BUYERS_AGENT_PATHNAME)) {
            _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.trackAuthPage */ .ep.trackAuthPage(_helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.authTrackingPageName.BAA_BUYERS_AGENT_SIGN_IN */ .ep.authTrackingPageName.BAA_BUYERS_AGENT_SIGN_IN);
        } else if (documentReferrer.includes(_lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.BOOKING_APPOINTMENT_PATHNAME */ .C1.BOOKING_APPOINTMENT_PATHNAME)) {
            _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.trackAuthPage */ .ep.trackAuthPage(_helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.authTrackingPageName.BAA_SIGN_IN */ .ep.authTrackingPageName.BAA_SIGN_IN);
            var L3 = (0,_lendi_lendigroup_leads_library__WEBPACK_IMPORTED_MODULE_5__/* .createLead */ .$D)(_lendi_lendigroup_leads_library__WEBPACK_IMPORTED_MODULE_5__/* .Origin.AppointmentBooking */ .aP.AppointmentBooking);
            L3.set({
                accountOrigin: "".concat(window.location.host).concat(_lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.BOOKING_APPOINTMENT_PATHNAME */ .C1.BOOKING_APPOINTMENT_PATHNAME)
            });
        } else if (documentReferrer.includes(_lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.STAMP_DUTY_PATHNAME */ .C1.STAMP_DUTY_PATHNAME)) {
            _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.trackAuthPage */ .ep.trackAuthPage(_helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.authTrackingPageName.STAMP_DUTY_SIGN_IN */ .ep.authTrackingPageName.STAMP_DUTY_SIGN_IN);
        } else if (documentReferrer.includes(_lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.PROPERTY_REPORT_PATHNAME */ .C1.PROPERTY_REPORT_PATHNAME)) {
            _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.trackAuthPage */ .ep.trackAuthPage(_helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.authTrackingPageName.PROPERTY_REPORT_SIGN_IN */ .ep.authTrackingPageName.PROPERTY_REPORT_SIGN_IN);
        } else if (documentReferrer.includes(_lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.REFER_A_FRIEND_PATHNAME */ .C1.REFER_A_FRIEND_PATHNAME)) {
            _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.trackAuthPage */ .ep.trackAuthPage(_helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.authTrackingPageName.REFER_A_FRIND_SIGN_IN */ .ep.authTrackingPageName.REFER_A_FRIND_SIGN_IN);
        } else if (documentReferrer.includes(_lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.CHECK_YOUR_CREDIT_SCORE_PATHNAME */ .C1.CHECK_YOUR_CREDIT_SCORE_PATHNAME || _lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.FREE_CREDIT_SCORE_CHECK_PATHNAME */ .C1.FREE_CREDIT_SCORE_CHECK_PATHNAME || _lendi_core_constants__WEBPACK_IMPORTED_MODULE_3__/* .PlatformPathname.CREDIT_SCORE_RESULT_PATHNAME */ .C1.CREDIT_SCORE_RESULT_PATHNAME)) {
            _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.trackAuthPage */ .ep.trackAuthPage(_helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.authTrackingPageName.CREDIT_SCORE_SIGN_IN */ .ep.authTrackingPageName.CREDIT_SCORE_SIGN_IN);
        } else {
            if (textKey === "returned") {
                _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.trackAuthPage */ .ep.trackAuthPage(_helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.authTrackingPageName.SIGN_IN_MARKETING */ .ep.authTrackingPageName.SIGN_IN_MARKETING);
            }
            _helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.trackAuthPage */ .ep.trackAuthPage(_helpers_tracking__WEBPACK_IMPORTED_MODULE_21__/* .pageTracking.authTrackingPageName.SIGN_IN */ .ep.authTrackingPageName.SIGN_IN);
        }
    }, [
        identifyCalled
    ]);
    (0,_helpers__WEBPACK_IMPORTED_MODULE_18__/* .useRedirect */ .eR)();
    return ldReady ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_AuthenticationFlowLayout__WEBPACK_IMPORTED_MODULE_24__/* .AuthenticationFlowLayout */ .L, {
        children: brand === _lendi_lala_react__WEBPACK_IMPORTED_MODULE_4__/* .Brand.Aussie */ .H2.Aussie && subbiesPostcodeBeforeAuth && !postcodeHidden ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_postcode__WEBPACK_IMPORTED_MODULE_28__["default"], {
            hidePostcode: hidePostcode
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_BoldHeading__WEBPACK_IMPORTED_MODULE_16__/* .BoldHeading */ .V, {
                    size: "lg",
                    as: "h1",
                    color: "shade.700",
                    mt: "xl",
                    mb: "sm",
                    align: "center",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
                    size: "lg",
                    color: "shade.600",
                    align: "center",
                    mt: "md",
                    mb: "lg",
                    children: subtitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    halign: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Unit */ .ZP.Unit, {
                            size: {
                                xs: 1,
                                md: 2 / 3
                            },
                            children: [
                                !hideOtp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_8__/* .Form */ .l0, {
                                    initialValues: {
                                        phoneNumber: (0,_helpers_util__WEBPACK_IMPORTED_MODULE_30__/* .formatInitialPhoneNumber */ .Z1)(phoneNumber || "")
                                    },
                                    validate: _helpers_validation__WEBPACK_IMPORTED_MODULE_22__/* .validate */ .Gu,
                                    onSubmit: handleSubmit,
                                    children: function(param) {
                                        var handleSubmit = param.handleSubmit, invalid = param.invalid;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pages_styles_index_style__WEBPACK_IMPORTED_MODULE_25__/* .AuthForm */ .Bt, {
                                            style: {
                                                textAlign: "center"
                                            },
                                            onSubmit: handleSubmit,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FieldComponents__WEBPACK_IMPORTED_MODULE_13__/* .MobileField */ .Yw, {
                                                    autoFocus: true,
                                                    error: error,
                                                    resetAuthError: resetError
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorComponents__WEBPACK_IMPORTED_MODULE_12__/* .AlertError */ .ne, {
                                                    error: error
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_ButtonWithMargin__WEBPACK_IMPORTED_MODULE_17__/* .Button */ .z, {
                                                    type: "submit",
                                                    mt: "md",
                                                    isFullWidth: true,
                                                    variant: "primary",
                                                    isDisabled: invalid || loading || codeSent,
                                                    children: "Get one-time passcode"
                                                })
                                            ]
                                        });
                                    }
                                }),
                                !hideSso && ssoSignIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        !hideOtp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DividerComponent__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_GoogleSignInComponent__WEBPACK_IMPORTED_MODULE_14__/* .GoogleSignInButton */ .N, {
                                            verifying: loading,
                                            error: error
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DisclaimerComponent__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    buttonText: hideOtp ? "SIGN IN WITH GOOGLE" : "GET ONE-TIME PASSCODE"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EncryptionComponent__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                            ]
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
Login.displayName = "Login";
/* harmony default export */ __webpack_exports__["default"] = (Login);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [932,319,391,187,434,163,23,642,267,385,151,247,852,771,774,888,179], function() { return __webpack_exec__(4878); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);